module.exports = __webpack_public_path__ + "img/video_poster.8228198a.png";